import { useEffect } from 'react';
import useShallowEqualSelector from '../../CustomHooks/useShallowEqualSelector';
import FullPageLoadingIndicator from '../LoadingIndicator/FullPageLoadingIndicator';

const StepUpRequest = ({ oidc }) => {
    const { locale, clientNumber, certificateNumber, group, isOtip, entityId } = useShallowEqualSelector((state) => ({
        locale: state.Authentication.language,
        clientNumber: state.MemberData.member.clientNumber,
        certificateNumber: state.MemberData.member.certificateNumber,
        group: state.Authentication.group,
        isOtip: state.Context.isOtip,
        entityId: state.Authentication.entityId,
    }));

    useEffect(() => {
        const performStepUpAuthentication = async () => {
            const params = new URLSearchParams(window.location.search);
            const returnPath = params.get('returnPath');

            try {
                await oidc.performStepUpAuthentication(
                    locale,
                    returnPath,
                    clientNumber,
                    certificateNumber,
                    group,
                    isOtip,
                    entityId
                );
            } catch (err) {
                window.history.back();
            }
        };

        performStepUpAuthentication();
    }, [oidc, locale, clientNumber, certificateNumber, group, isOtip, entityId]);

    return <FullPageLoadingIndicator />;
};

export default StepUpRequest;
